/**
 * Dev environment
 *
 * Put what you like in it, but DON'T use it to build prod !
 */
export const environment = {
  production: false,
  title: 'ويزشات، دردشة بلا حدود',
  api: 'https://chat-api-new-pp.contactdve.com/api',
  graphQL: 'https://api.pp.weezchat.fr/graphql',
  chat: 'https://pp-chat-liveengine.contactdve.com/',

  waitingAPI: 'dating-notification-pp.dv-content.io/',
  waitingToken: 'TtD4dFtMCfu92eCK',
  completeProfileInputs: ['phoneNumber'],
  gtm: 'GTM-P754KZ',
  gtmCountry: 'GTM-KT42SH4',
  id: 'fedec0c6-2262-4b38-b4bc-5d79bc4c7077',
  dvp4m: true,
  gsv: null,

  appLink: null,
  didomi: null,
};
